var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.current_staff)?_c('div',[_c('staff-form',{model:{value:(_vm.current_staff),callback:function ($$v) {_vm.current_staff=$$v},expression:"current_staff"}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }